import FetchException from '../FetchException';

export default class NotFoundException extends FetchException {
	constructor(message = 'Not Found', additionalContext = {}) {
		super(message, additionalContext);
	}
}
